import React, { useRef, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import {getPrivileges} from '../../../functions/Auth';

const SummaryCard = props => {
    return (
        <Card className='mb-sumary-info'>
                <Grid container>                    
                    <Grid item className='mb-sumary-row mb-sumary-row-lb mb-sumary-row-bk mb-sumary-row-hd' xs={props.yearList.length==1?9:6}>
                        Year
                    </Grid>
                    {props.yearList.map((year, index) => {
                        return <Grid item className='mb-sumary-row mb-sumary-row-bk mb-sumary-row-hd' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                            {year.year}
                        </Grid>
                    })}
                    <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                        Average daily traffic (ADT)
                    </Grid>
                    {(props.getADTSummery.length>0)?props.getADTSummery.map((adt, index) => {
                            return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                {adt.value}
                            </Grid>
                        })
                    :null}
                    <Grid item className='mb-sumary-row mb-sumary-row-lb mb-sumary-row-bk' xs={props.yearList.length==1?9:6}>
                        Truck %
                    </Grid>
                    {(props.getTruckPercent.length>0)?props.getTruckPercent.map((trunk, index) => {
                            return <Grid item className='mb-sumary-row mb-sumary-row-bk' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                {trunk.value}{trunk.value!='N/A'?'%':''}
                            </Grid>
                        })
                    :null}
                    <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                        ADT annual growth rate %
                    </Grid>
                    {(props.getADTGrowthFactor.length>0)?props.getADTGrowthFactor.map((adtgrow, index) => {
                            return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                {adtgrow.value}{adtgrow.value!='N/A'?'%':''}
                            </Grid>
                        })
                    :null}
                    {(getPrivileges().length !== 0)?
                    <>
                        <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                            K factor
                        </Grid>
                        {(props.getKFactor.length>0)?props.getKFactor.map((item, index) => {
                                return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                    {item.value === "" ? "N/A" : item.value}
                                </Grid>
                            })
                        :null}     
                        <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                            D factor
                        </Grid>
                        {(props.getDFactor.length>0)?props.getDFactor.map((item, index) => {
                                return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                    {item.value === "" ? "N/A" : item.value}
                                </Grid>
                            })
                        :null}   
                        <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                            LOS
                        </Grid>
                        {(props.getLOS.length>0)?props.getLOS.map((item, index) => {
                                return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                    {item.los === "" ? "N/A" : item.los}
                                </Grid>
                            })
                        :null}      
                    </>
                    :null
                    }
                    <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                        Peak hour
                    </Grid>
                    {(props.getPeakHr.length>0)?props.getPeakHr.map((item, index) => {
                            return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                {item.value === "" ? "N/A" : item.value}
                            </Grid>
                        })
                    :null}
                    <Grid item className='mb-sumary-row mb-sumary-row-lb' xs={props.yearList.length==1?9:6}>
                        Peak hour direction
                    </Grid>
                    {(props.getPeakDir.length>0)?props.getPeakDir.map((item, index) => {
                            return <Grid item className='mb-sumary-row' xs={props.yearList.length==1?3:6/(props.yearList.length)}>
                                {item.value === "" ? "N/A" : item.value}
                            </Grid>
                        })
                    :null}                                                                
                </Grid>               
            </Card>
      )
}
export default SummaryCard;